import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import { getSMPBackendAPIAdmin } from '@/proxy/apiController';
import { toResourceDocument } from '@/services';

function getResourceDocuments(resourceId: string) {
  return getSMPBackendAPIAdmin().resourceDocumentsControllerFindAllV1(resourceId);
}

export function useResourceDocuments(resourceId: string) {
  return useQuery({
    queryKey: queryKeys.resourceDocuments.lists(resourceId),
    queryFn: () => getResourceDocuments(resourceId),
    select: (data) => data.map(toResourceDocument),
    enabled: !!resourceId,
  });
}
